/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipTypeEnrollmentLinksViewModel } from "../types/ScholarshipTypeEnrollmentLinksViewModel.ts";
import { scholarshipTypeLinkViewModelSchema } from "./scholarshipTypeLinkViewModelSchema.ts";

export const scholarshipTypeEnrollmentLinksViewModelSchema = z.object({
  scholarshipTypeId: z.optional(
    z.number().int().describe("ID do tipo de bolsa."),
  ),
  classStudentId: z
    .string()
    .describe("IDs das turmas vinculadas (CSV), como armazenado na bolsa.")
    .nullish(),
  scholarshipTypeDesc: z
    .string()
    .describe("Descrição do tipo de bolsa.")
    .nullish(),
  links: z
    .array(z.lazy(() => scholarshipTypeLinkViewModelSchema))
    .describe("Links de matrícula, um item por turma vinculada.")
    .nullish(),
}) as unknown as ToZod<ScholarshipTypeEnrollmentLinksViewModel>;
